import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectMasterDealer = createSelector([selectPartner360Data], ({ masterDealer }) => ({
  masterDealer,
}))
